module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAU1JREFUWAntkz9KQ0EQh/NU0qXSRhFiK4IIKYKtNwjkBDZCDhHiPbyDTdKmF2wstTAWEquc4fn9YBOSZv+4myBhFj42b2fm23mTpNGwZROwCdgEbAI2AZvAXkygrusHWF/9f/lidDgq2ViVK6OhLo4e3ME5HMMCvmEKz1VVvbDvdtFYB6bwDo9wC6fQdLueda648jo765DLBjCHezj0Xay4y1P+wJdbJMYlQ3iDdoqQ/AtXN0ypS8rlgj58wklSoUtWnasv/w9H3IIfuPlLc8sa1TtPa3lWZEeqH/xTCZk88pVwrRwIv+BydZDxQR6YZSg2S5Fdw8fmad6TfPKGLAehBBe/Yn+NzI1Nk09e74pt8AzL3GtKD8onb97iaxjDNtc4q0N1liUIFIf8sV9x4JrthY8i1JPQW0Y4fCkTX9BiNgGbgE3AJmAT2PMJ/AJRykGwMVpicgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/menu.png
// module id = 435
// module chunks = 0